<!-- ============================================================== -->
<!-- Fixed height Card Grid-->
<!-- ============================================================== -->
<div class="row">
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <h4 class="mb-32">Basic Tooltip</h4>

        <span matTooltip="Tooltip!" class="fs-18">I have a tooltip</span>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<!-- ============================================================== -->
<!-- Fixed height Card Grid-->
<!-- ============================================================== -->
<div class="row">
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <h4 class="mb-32">Positioning Tooltip</h4>

        <div class="button-row">
          <button mat-raised-button color="accent" matTooltip="Tooltip!" matTooltipPosition="above"
            class="me-8 mb-8">Above
            tooltip</button>
          <button mat-raised-button color="warn" matTooltip="Tooltip!" matTooltipPosition="below"
            class="me-8 mb-8">below tooltip</button>
          <button mat-raised-button color="primary" matTooltip="Tooltip!" matTooltipPosition="left"
            class="me-8 mb-8">left
            tooltip</button>
          <button mat-raised-button color="warn" matTooltip="Tooltip!" matTooltipPosition="right"
            class="me-8 mb-8">right tooltip</button>
          <button mat-raised-button color="accent" matTooltip="Tooltip!" matTooltipPosition="before"
            class="me-8 mb-8">Before
            tooltip</button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<mat-card>
  <mat-card-content>
    <h4 class="mb-32">Custom Class Tooltip</h4>

    <button mat-raised-button matTooltip="Info about the action" matTooltipClass="example-tooltip-red"
      aria-label="Button that shows a red tooltip" class="example-button">
      Red-tooltip Action
    </button>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>
    <h4 class="mb-32">Manually Shown/Hidden Tooltip</h4>
    <div>
      <span> Click the following buttons to... </span>
      <button mat-button (click)="tooltip.show()" aria-label="Show tooltip on the button at the end of this section"
        class="example-action-button">
        show
      </button>
      <button mat-button (click)="tooltip.hide()" aria-label="Hide tooltip on the button at the end of this section"
        class="example-action-button">
        hide
      </button>
      <button mat-button (click)="tooltip.toggle()"
        aria-label="Show/Hide tooltip on the button at the end of this section" class="example-action-button">
        toggle show/hide
      </button>
    </div>

    <button mat-raised-button #tooltip="matTooltip" matTooltip="Info about the action" matTooltipPosition="right"
      aria-tooltip="Button that displays and hides a tooltip triggered by other buttons">
      Action
    </button>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>
    <h4 class="mb-32">Show And Hide Delay Tooltip</h4>

    <button mat-raised-button matTooltip="By default, I delay"
      aria-label="Button that displays a tooltip that has custom delays through a default config">
      Button with delay-default tooltip
    </button>
  </mat-card-content>
</mat-card>
